import {
  data,
  LoaderFunctionArgs,
  Outlet,
  useLoaderData,
  useOutletContext,
} from "react-router";
import invariant from "tiny-invariant";

import { TExternalCampaignDetails } from "@/types";

export async function loader({ params }: LoaderFunctionArgs) {
  const { externalCampaignId } = params;
  invariant(externalCampaignId, "No external campaign id found.");

  // Fetch external campaign data to show information related to it
  const externalCampaignResponse = await fetch(
    `/api/client/external_campaigns/${externalCampaignId}`
  );
  if (externalCampaignResponse.status !== 200) {
    throw data("Failed to load externalCampaign", {
      status: externalCampaignResponse.status,
    });
  }

  const { data: externalCampaign } =
    (await externalCampaignResponse.json()) as {
      data: TExternalCampaignDetails;
    };

  return { externalCampaign };
}

type ContextType = {
  externalCampaign: TExternalCampaignDetails;
};

// See https://reactrouter.com/en/main/hooks/use-outlet-context
export function useExternalCampaignContext() {
  return useOutletContext<ContextType>();
}

function ExternalCampaign() {
  const { externalCampaign } = useLoaderData<typeof loader>();

  return <Outlet context={{ externalCampaign } satisfies ContextType} />;
}

export default ExternalCampaign;
